export default (theme) => ({
  ownershipDialog: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  iconButton: {
    padding: 8,
    paddingTop: 0,
    paddingBottom: 0,
    boxShadow: "none",
    "&&:hover": {
      backgroundColor: "transparent",
    },
    display: "inline-block",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  recordName: {
    fontSize: 14,
    fontWeight: "bold",
  },
});
